import { Component, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { Login } from './login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService],
})
export class LoginComponent implements OnInit {
  private username: String;
  private password: String;
  private company_code: String;

  private isError: boolean = false;
  private errorMsg: string;

  private dataLogin: Login;

  constructor(private loginService: LoginService, private router: Router) {}

  ngOnInit() {}

  lookData() {
    if (this.company_code && this.username && this.password) {
      this.loginService.postLogin(this.company_code, this.username, this.password).subscribe({
        next: (dataLogin) => {
          this.dataLogin = dataLogin;
          if (this.dataLogin.status !== 'success') {
            this.errorMsg = this.dataLogin.message;
            this.isError = true;
          } else if (this.dataLogin.authority === 0) {
            localStorage.setItem('user', JSON.stringify(this.dataLogin));
            this.router.navigate(['dashboard']);
          } else {
            this.errorMsg = "You're not authorized to access this site";
            this.isError = true;
          }
        },
        error: (err) => {
          this.errorMsg = err.error.message;
          this.isError = true;
        },
      });
    } else {
      this.errorMsg = 'Please fill all input form :)';
      this.isError = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts